import './Push.sass';

import React, { FC } from 'react';
import { PushInterface } from '$shared/components/Pushes/Push/Push.interface';
import { UnitPhoto } from '$shared/components';
import { useUserInfo } from '$hooks';
import { IcClose16 } from '$assets';
import { PushType } from '$store/pushes/interface';

export const Push: FC<PushInterface> = ({ push, onClose, type, onClick, onHover }) => {
  const user = useUserInfo(push.userId);

  return (
    <div
      className="Push"
      onClick={onClick}
      onMouseEnter={() => onHover && onHover(true)}
      onMouseLeave={() => onHover && onHover(false)}
    >
      <div className="Push__photo">
        <UnitPhoto
          onlineIndicator={false}
          unit={user}
          round
          hasLive={type == PushType.LIVE}
        />
      </div>
      <div className="Push__body">
        <div className="Push__body__title">{push.title}</div>
        <div className="Push__body__text">{push.text}</div>
      </div>
      <div
        className="Push__close"
        onClick={(e) => {
          e.stopPropagation();
          onClose && onClose();
        }}
      >
        <IcClose16 />
      </div>
    </div>
  );
};
